import React from "react";
import { Link } from "react-router-dom";
import { Navigation } from "./navigation";

export const WorkshopsPage = (props) => {
  if (!props.data) return "loading";

  const { title, subtitle, customWorkshop, workshops, upcomingWorkshops } =
    props.data;

  return (
    <div className="workshops-page">
      <Navigation />
      {/* Header Section */}
      <div className="workshops-hero">
        <div className="container">
          <div className="workshops-hero-content">
            <h1>Join My Workshops</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="workshops-layout">
          {/* Left Side - Upcoming & Past Workshops */}
          <div className="workshops-left">
            {/* Upcoming Workshops */}
            <div className="upcoming-workshops-section">
              <div className="upcoming-workshops-cards">
                {upcomingWorkshops.map((workshop, idx) => (
                  <div key={workshop.id} className="upcoming-workshop-card">
                    <div className="upcoming-workshop-header">
                      <h4 className="upcoming-workshop-title">
                        {workshop.title}
                      </h4>
                      <div className="upcoming-workshop-date">
                        <i className="fa fa-calendar"></i> {workshop.date}
                      </div>
                    </div>
                    <p className="upcoming-workshop-description">
                      {workshop.description}
                    </p>
                    <div className="upcoming-workshop-meta">
                      <span className="upcoming-workshop-duration">
                        <i className="fa fa-clock-o"></i> {workshop.duration}
                      </span>
                      <span className="upcoming-workshop-participants">
                        <i className="fa fa-users"></i>{" "}
                        {workshop.maxParticipants} max
                      </span>
                    </div>
                    <div className="upcoming-workshop-price">
                      {workshop.price}
                    </div>
                    <a href="#contact" className="btn btn-upcoming btn-sm">
                      Register Now
                    </a>
                  </div>
                ))}
              </div>
            </div>

            {/* Past Workshops */}
            <div className="past-workshops-section">
              <h2 className="section-title">Past Workshops</h2>
              <div className="workshops-articles">
                {workshops.map((workshop, idx) => (
                  <article key={workshop.id} className="workshop-article">
                    <div className="article-header">
                      <div className="article-date">
                        <i className="fa fa-calendar"></i>{" "}
                        {workshop.date || "Date TBD"}
                      </div>
                      <h3 className="article-title">{workshop.title}</h3>
                      <div className="article-meta">
                        <span className="article-duration">
                          <i className="fa fa-clock-o"></i> {workshop.duration}
                        </span>
                        <span className="article-level">
                          <i className="fa fa-star"></i> {workshop.level}
                        </span>
                        <span className="article-participants">
                          <i className="fa fa-users"></i>{" "}
                          {workshop.maxParticipants} participants
                        </span>
                      </div>
                    </div>

                    <div className="article-content">
                      <p className="article-description">
                        {workshop.description}
                      </p>

                      <div className="article-includes">
                        <h4>What We Covered:</h4>
                        <ul>
                          {workshop.includes.map((item, itemIdx) => (
                            <li key={itemIdx}>
                              <i className="fa fa-check"></i> {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Photo Gallery - Always Visible */}
                    <div className="article-gallery">
                      <h4>Workshop Gallery</h4>
                      <div className="photo-grid">
                        {workshop.photos.map((photo, photoIdx) => (
                          <div key={photoIdx} className="photo-item">
                            <img
                              src={photo}
                              alt={`${workshop.title} workshop demonstration ${
                                photoIdx + 1
                              }`}
                              className="workshop-photo"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side - Book Custom Workshop */}
          <div className="workshops-right">
            {/* Custom Workshop */}
            <div className="custom-workshop-section">
              <div className="custom-workshop-card">
                <div className="custom-workshop-content">
                  <h3>{customWorkshop.title}</h3>
                  <p>{customWorkshop.description}</p>
                  <ul className="custom-workshop-features">
                    {customWorkshop.features.map((feature, idx) => (
                      <li key={idx}>
                        <i className="fa fa-check"></i> {feature}
                      </li>
                    ))}
                  </ul>
                  <a
                    href="#contact"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Book Custom Workshop
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
